import { render, staticRenderFns } from "./UploadEnvelope.vue?vue&type=template&id=df81deec"
import script from "./UploadEnvelope.vue?vue&type=script&lang=js"
export * from "./UploadEnvelope.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports